export default __webpack_public_path__ + "static/media/FeIcon2.e9366e0f.svg";